import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { gettravelPackageList } from "../store/slices/tourpackage";
import HTMLRenderer from "./render";

const PackageDetails = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [categoryId, setcategoryId] = useState("");
  const [upperLimit, setupperLimit] = useState("");
  const [duration, setDuration] = useState("");
  const [places, setPlaces] = useState([]);
  const [packageName, setpackageName] = useState("");
  const [packagebaseRate, setpackagebaseRate] = useState();
  const [extrabedPrice, setextrabedPrice] = useState("");
  const [childPrice, setchildPrice] = useState("");
  const [ticketsPrice, setticketsPrice] = useState("");
  const [description, setDescription] = useState("");
  const [platformCharges, setplatformCharges] = useState("");
  const [images, setImages] = useState([]);
  const [roomRate, setroomRate] = useState([]);
  const [carRate, setcarRate] = useState([]);
  const [inclusive, setInclusive] = useState("");
  const [exclusive, setExclusive] = useState("");
  const [termsCondition, settermsCondition] = useState("");
  const [paymentPolicy, setpaymentPolicy] = useState("");
  const [cancellationPolicy, setcancellationPolicy] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchPackageDetails = async () => {
      try {
        const data = await dispatch(gettravelPackageList({ id })).unwrap();
        const packagedata = data?.packageData[0];

        const clonedTourIternary = (packagedata.tourIternary || []).map(
          (item, index) => ({
            ...item,
            id: `${Date.now()}-${index}`,
            breakfast: Boolean(item.breakfast),
            lunch: Boolean(item.lunch),
            dinner: Boolean(item.dinner),
          }),
        );
        settourIternary(clonedTourIternary);
        setpackageName(packagedata.packageName);
        setplatformCharges(packagedata.platformCharges);
        setcategoryId(packagedata.categoryId);
        setDuration(packagedata.duration);
        setpackagebaseRate(packagedata.packagebaseRate);
        setextrabedPrice(packagedata.extrabedPrice);
        setchildPrice(packagedata.childPrice);
        setticketsPrice(packagedata.ticketsPrice);
        setroomRate(packagedata.roomRate);
        setcarRate(packagedata.carRate);
        setDescription(packagedata.description);
        setImages(packagedata.images);
        setInclusive(packagedata.inclusive);
        setExclusive(packagedata.exclusive);
        settermsCondition(packagedata.termsCondition);
        setpaymentPolicy(packagedata.paymentPolicy);
        setcancellationPolicy(packagedata.cancellationPolicy);
        const clonedHotelDetails = (packagedata.hotelDetails || []).map(
          (item, index) => ({
            ...item,
            id: `${Date.now()}-${index}`,
          }),
        );

        sethotelDetails(clonedHotelDetails);

        const formattedPlaces = (packagedata.places || []).map((place) => ({
          placeId: place.placeId,
          name: place.name,
        }));
        setPlaces(formattedPlaces);
        setupperLimit(packagedata.upperLimit);
      } catch (error) {
        console.error("Error fetching package details:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPackageDetails();
  }, [dispatch, id]);

  const [hotelDetails, sethotelDetails] = useState([
    {
      id: Date.now(),
      hotelName: "",
      place: "",
      duration: "",
      capacityPerRoom: "",
      starRating: "",
      roomType: "",
    },
  ]);

  const [tourIternary, settourIternary] = useState([
    {
      id: Date.now(),
      title: "",
      description: "",
      breakfast: false,
      lunch: false,
      dinner: false,
    },
  ]);

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Package Details</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/tour-package"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Packages
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Package Details</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <div className="row mb-40">
            <div className="col-md-5">
              <label className="form-label">Package Name</label>
              <p>{packageName}</p>
            </div>
            <div className="col-md-5">
              <label className="form-label">Package Category</label>
              <p>{categoryId.categoryName}</p>
            </div>
            <div className="col-md-10 mt-3">
              <label className="form-label">Places</label>
              <p> {places.map((place) => place.name).join(", ")}</p>
            </div>
            <div className="col-md-5 mt-3">
              <label className="form-label">Duration</label>
              <p>{duration}</p>
            </div>
            <div className="col-md-5 mt-3">
              <label className="form-label">Upper Limit</label>
              <p>{upperLimit}</p>
            </div>
            <div className="col-md-5 mt-3">
              <label className="form-label">Room Rates</label>
              <div className="container-fluid">
                <table className="table striped-table mb-0">
                  <thead>
                    <tr>
                      <th>Place</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roomRate?.map((items, index) => (
                      <tr key={index}>
                        <td>{items.day}</td>
                        <td>{items.price}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-md-5 mt-3">
              <label className="form-label">Car Rates</label>
              <div className="container-fluid">
                <table className="table striped-table mb-0">
                  <thead>
                    <tr>
                      <th>Pax</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {carRate?.map((items, index) => (
                      <tr key={index}>
                        <td>
                          {items.minPax} - {items.maxPax}
                        </td>
                        <td>{items.price}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-md-5 mt-3">
              <label className="form-label">Package Price</label>
              <p>{packagebaseRate}</p>
            </div>
            <div className="col-md-5 mt-3">
              <label className="form-label">Extrabed Price</label>
              <p>{extrabedPrice}</p>
            </div>
            <div className="col-md-5 mt-3">
              <label className="form-label">Child With Bed Price</label>
              <p>{childPrice}</p>
            </div>
            <div className="col-md-5 mt-3">
              <label className="form-label">Entry Fees</label>
              <p>{ticketsPrice}</p>
            </div>
            <div className="col-md-5 mt-3">
              <label className="form-label">Platform Charges</label>
              <p>{platformCharges}</p>
            </div>

            <div className="col-md-11 mt-3">
              <label className="form-label">Images</label>
              <div className="row mt-3">
                {images?.map((img, index) => (
                  <div className="col-md-2 mb-2 position-relative" key={index}>
                    <img
                      src={img.mediaLink}
                      style={{ height: "120px", objectFit: "cover" }}
                      alt=""
                      className="img-thumbnail"
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-11 mt-3">
              <label className="form-label">Description</label>

              <p className="mt-25">
                <HTMLRenderer htmlContent={description} />
              </p>
            </div>
            <div className="col-md-11 mt-3">
              <label className="form-label">Itinerary</label>
              <div className="question-form">
                {tourIternary?.map((item) => (
                  <div
                    key={item.id}
                    className="container border p-3 mb-3 rounded"
                  >
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <label className="form-label">Title</label>
                        <p>{item.title}</p>
                      </div>
                      <div className="col-md-2 mt-5">
                        <div className="form-switch switch-purple d-flex align-items-center gap-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            checked={item.breakfast}
                          />
                          <label className="form-check-label line-height-1 fw-medium text-secondary-light">
                            Breakfast
                          </label>
                        </div>
                      </div>
                      <div className="col-md-2 mt-5">
                        <div className="form-switch switch-success d-flex align-items-center gap-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            checked={item.lunch}
                          />
                          <label className="form-check-label line-height-1 fw-medium text-secondary-light">
                            Lunch
                          </label>
                        </div>
                      </div>
                      <div className="col-md-2 mt-5">
                        <div className="form-switch switch-warning d-flex align-items-center gap-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            checked={item.dinner}
                          />
                          <label className="form-check-label line-height-1 fw-medium text-secondary-light">
                            Dinner
                          </label>
                        </div>
                      </div>
                      <div className="col-md-12 mt-3">
                        <label className="form-label">Details</label>

                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.description,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-11 mt-3">
              <label className="form-label">Hotel Details</label>
              <div className="container-fluid">
                <table className="table striped-table mb-0">
                  <thead>
                    <tr>
                      <th>Place</th>
                      <th>Hotel</th>
                      <th>Nights</th>
                      <th>Occupancy</th>
                      <th>Room Type</th>
                      <th>Star Rating</th>
                    </tr>
                  </thead>
                  <tbody>
                    {hotelDetails?.map((items, index) => (
                      <tr key={index}>
                        <td>{items.place}</td>
                        <td>{items.hotelName}</td>
                        <td>{items.duration}</td>
                        <td>{items.capacityPerRoom}</td>

                        <td>{items?.roomType}</td>
                        <td>{items?.starRating}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="col-md-11 mt-3">
              <label className="form-label">Inclusion</label>

              <p className="mt-25">
                <HTMLRenderer htmlContent={inclusive} />
              </p>
            </div>
            <div className="col-md-11 mt-3">
              <label className="form-label">Exclusion</label>
              <p className="mt-25">
                <HTMLRenderer htmlContent={exclusive} />
              </p>
            </div>
            <div className="col-md-11 mt-3">
              <label className="form-label">Terms and Conditions</label>
              <p className="mt-25">
                <HTMLRenderer htmlContent={termsCondition} />
              </p>
            </div>
            <div className="col-md-11 mt-3">
              <label className="form-label">Payment Policy</label>
              <p className="mt-25">
                <HTMLRenderer htmlContent={paymentPolicy} />
              </p>
            </div>
            <div className="col-md-11 mt-3">
              <label className="form-label">Cancel Policy</label>
              <p className="mt-25">
                <HTMLRenderer htmlContent={cancellationPolicy} />
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PackageDetails;
